/*
 * @Description: A whole uploader component mainly for collapse group usage
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:05:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-19 14:55:39
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/Uploader/index.tsx
 */

import React, { useState } from 'react';
import _ from 'lodash';
import classname from 'classnames';

import { Button } from '../../Antd';
import ImageDisplay, { Type } from '../ImageDisplay';
import UploadModal from '../UploadModal';
import EditModal from '../EditModal';
import { ImageFile } from '../ImageDisplay/imageDisplay';

import styles from './style.module.less';
import { mediaTypeCheck } from 'src/tools/helper';
import { get } from 'lodash';
import { MediaType } from 'src/types/common/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

type Props = {
  type?: 'Image' | 'Video' | 'Both';
  width?: number | string;
  height?: number;
  imageWidth?: number | string;
  title?: string;
  description?: string;
  btnText?: string;
  multiple: boolean;
  multipleSize?: number;
  fileList: Array<ImageFile>;
  onChange: (info: Array<ImageFile>) => void;
  ImageContainer?: any | React.ReactElement;
  hideRemove?: boolean;
  hideReplace?: boolean;
  hideEdit?: boolean;
  hideOriginalName?: boolean;
  hideSize?: boolean;
  disabled?: boolean;
};

function Uploader({
  width = '100%',
  height = 148,
  type = 'Image',
  title = 'or drag and drop file here',
  description: _description,
  multiple,
  imageWidth,
  multipleSize,
  fileList = [],
  onChange,
  ImageContainer,
  hideRemove,
  hideReplace,
  hideEdit,
  hideOriginalName,
  hideSize,
  disabled,
  btnText,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const description =
    _description ||
    `(${getI18n('general.allowedfiletypes')}: jpeg, gif, svg, png)`;
  const currentType = mediaTypeCheck(get(fileList, '0'));
  const isCurrentImage = MediaType.Image === currentType;
  const isCurrentVideo = MediaType.Video === currentType;
  const size = () => {
    const _multipleSize = multipleSize || 1;
    if (_multipleSize > 1) {
      return _multipleSize;
    } else {
      if (multiple) {
        return _multipleSize;
      } else {
        return 1;
      }
    }
  };

  //const a = 1;
  //const isVideo = type === 'Video';
  const [visible, setVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [selectedImage, setSelectedImage] = React.useState({
    image: null,
    index: null,
  });

  const isSelected = _.get(selectedImage, 'image');

  const remainSize = () => {
    if (isSelected) {
      return 1;
    } else {
      const _s = size();
      const remain = _s - fileList.length;
      return remain;
    }
  };

  const handleShowModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setVisible(true);
  };

  const handleCleanFileList = (index?) => {
    if (multiple) {
      if (_.isNumber(index)) {
        const c = _.cloneDeep(fileList || []);
        c.splice(index, 1);
        onChange(c);
      } else {
        onChange([]);
      }
    } else {
      onChange([]);
    }
  };

  const handleSubmit = (list) => {
    if (multiple) {
      const c = _.cloneDeep(fileList || []);
      if (isSelected) {
        const selectedIndex = selectedImage.index;
        const image = get(list, '0');
        if (image) {
          c.splice(selectedIndex, 1, image);
        } else {
          c.splice(selectedIndex, 1);
        }
        onChange(c);
      } else {
        const _c = [...c, ...list];
        onChange(_c);
      }
    } else {
      onChange(list);
    }
    setVisible(false);
    defaultSelectSetting();
  };

  const hideModal = () => {
    setVisible(false);
  };

  const defaultSelectSetting = () => {
    setSelectedImage({
      image: null,
      index: null,
    });
  };
  const hideEditModal = () => {
    setEditModal(false);
    defaultSelectSetting();
  };
  const editOnOk = (image, index) => {
    if (fileList) {
      const _f = _.cloneDeep(fileList || []);
      _f.splice(index, 1, image);
      onChange(_f);
    }
  };
  const isVideo = type === 'Video';
  const singleFileImageUrl = () => {
    // console.log('type', type);

    if (type === 'Image') {
      return (fileList[fileList.length - 1] || {}).url;
    }
    if (isVideo) {
      return (fileList[fileList.length - 1] || {}).firstFrameImageUrl;
    }
    if (type === 'Both') {
      //isCurrentImage
      if (isCurrentImage) {
        return (fileList[fileList.length - 1] || {}).url;
      }
      if (isCurrentVideo) {
        return (fileList[fileList.length - 1] || {}).url;
      }
    }

    //
    return null;
  };

  return (
    <>
      {/* <Spin spinning={loading} tip={`${loadingPercentage}%`}> */}
      {fileList && fileList.length <= 0 ? (
        <UploaderPlaceholder
          width={width}
          disabled={disabled}
          height={height}
          handleShowModal={handleShowModal}
          description={description}
          btnText={btnText}
        />
      ) : !multiple ? (
        <ImageDisplay
          imageUrl={singleFileImageUrl()} //video url changed
          type={Type.Fill}
          width={imageWidth || width}
          height={height}
          fileList={fileList}
          onRemove={handleCleanFileList} //当前状态下清空fileList
          onReplace={() => setVisible(true)}
          hideRemove={hideRemove || disabled}
          hideReplace={hideReplace || disabled}
          hideEdit={hideEdit || disabled || isVideo}
          hideOriginalName={hideOriginalName}
          hideSize={hideSize}
          onEdit={(image, index) => {
            setSelectedImage({
              image,
              index,
            });
            setEditModal(true);
          }}
        />
      ) : (
        fileList.map((i, index) => {
          //console.log('i,', i);
          // video目前还不支持多个
          return (
            <ImageContainer index={index} key={i.uuid}>
              <ImageDisplay
                index={index}
                imageUrl={i.url}
                type={Type.Fill}
                width={imageWidth || width}
                height={height}
                fileList={fileList}
                onRemove={() => {
                  handleCleanFileList(index);
                }} //当前状态下清空fileList
                onReplace={(image, index) => {
                  setSelectedImage({
                    image,
                    index,
                  });
                  setVisible(true);
                }}
                hideRemove={hideRemove || disabled}
                hideReplace={hideReplace || disabled}
                hideEdit={hideEdit || disabled}
                hideOriginalName={hideOriginalName}
                hideSize={hideSize}
                onEdit={(image, index) => {
                  setSelectedImage({
                    image,
                    index,
                  });
                  setEditModal(true);
                }}
              />
            </ImageContainer>
          );
        })
      )}
      {multiple && fileList.length < multipleSize && fileList.length > 0 && (
        <ImageContainer index={fileList.length}>
          <UploaderPlaceholder
            width={width}
            height={height}
            handleShowModal={handleShowModal}
            description={description}
            btnText={btnText}
          />
        </ImageContainer>
      )}
      {/* </Spin> */}
      <UploadModal
        type={type}
        size={remainSize()}
        visible={visible}
        onCancel={hideModal}
        width={1080}
        onOk={handleSubmit}
        // fileList={fileList}
      />
      {editModal && (
        <EditModal
          visible={editModal}
          onCancel={hideEditModal}
          image={selectedImage.image}
          onOk={editOnOk}
          index={selectedImage.index}
        />
      )}
    </>
  );
}

const UploaderPlaceholder = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { width, height, handleShowModal, description, disabled, btnText } =
    props;
  return (
    <div className={classname(styles.draggerContainer, 'override')}>
      {/* <Upload
              drag={true}
              multiple={multiple}
              setLoading={setLoading}
              setLoadingPercentage={setLoadingPercentage}
              fileList={fileList}
              onChange={onChange}> */}
      <div
        className={styles.dragger}
        style={{ height: height || undefined, width: width || undefined }}>
        <Button
          disabled={disabled}
          onClick={handleShowModal}
          type={'ghost'}
          className={styles.button}>
          {btnText || getI18n('general.selectImage')}
        </Button>
        {/* <div className={styles.title}>{title}</div> */}
        <div className={styles.desc}>{description}</div>
      </div>
      {/* </Upload> */}
    </div>
  );
};
export { UploaderPlaceholder };
export default Uploader;
